export function contentBoxConfig({ spacing }) {
    return {
        actionBarGroup: {
            borderRadius: "20px"
        },
        content: {
            padding: `${spacing.horizontalSpacing.horizWhiteSpacingmd}px ${spacing.verticalSpacing.vertWhiteSpacingmd}px`
        }
    };
}
